export const HistorialAmigoReferidoTabla =[
    
    {
      Header: "Tus Referidos",
      accessor: "correo_referido"
    },
    {
      Header: "Ecode Amigo",
      accessor: "Ecode_Referido"
    },
    {
        Header: "Registrado",
        accessor: "registrado"
    },
    {
        Header: "Tus puntos",
        accessor: "cantidad"
    }
  ];


  export const HistorialPuntosInicial={
    correo_referido:"-",
    registrado:"-",
    cantidad:"-"
  }